<template>
  <div>
    <EmbedWeetModal :weet="weet" :active.sync="embedModalActive"/>
    <div v-if="isMobile">
      <transition name="zoom">
        <w-button v-show="mustShow" tooltip="Share the link" tooltip-position="left"
                  tooltip-size="small" :size="size" :tooltip-delay="2000" class="buttonAction" icon="share"
                  :color="color" @click="shareLink">
        </w-button>
      </transition>
    </div>
    <div v-else>
      <transition name="zoom">
        <b-dropdown aria="list" position="is-top-left" expanded>
          <w-button v-show="mustShow" class="buttonAction" :size="size" icon="share" slot="trigger"
                    :color="color"/>

          <!-- LINK -->
          <b-dropdown-item class="dropItemShareing" @click="copyLink">
            <div class="sharingItem">
              <w-icon icon="link" color="black"/>
              <span class="socialLabel copyLink">
                   {{ $t('shareLinkButton.button.copy') }}
              </span>
            </div>
          </b-dropdown-item>

          <!-- EMBED -->
          <b-dropdown-item class="dropItemShareing" @click="shareEmbeddedWeet">
            <div class="sharingItem">
              <w-icon icon="code-tags" color="black"/>
              <span class="socialLabel embedLink">
                 {{ $t('shareLinkButton.button.embed') }}
              </span>
            </div>
          </b-dropdown-item>
        </b-dropdown>

      </transition>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import WButton from '@/components/wrapper/w-button.vue';
import {Weet} from '@/store/weet/weetModel';
import {getTabOfColor, getWeetURL} from '@/utils/util';

import mobileDetect from 'mobile-device-detect';
import WIcon from '@/components/wrapper/w-icon.vue';
import copy from 'copy-to-clipboard';
import {setActionEvent} from '@/utils/tracker';
import {ActionEvent} from '@/enum/TrackerEnum';
import EmbedWeetModal from '@/components/actionButton/EmbedWeetModal.vue';
import {inform} from '@/utils/dialog';

@Component({
  components: {EmbedWeetModal, WIcon, WButton},
})
export default class CopyWeetButton extends Vue {
  @Prop()
  private weet!: Weet;
  @Prop({default: 'default'})
  private size!: string;
  @Prop({default: 'outlined'})
  private color!: string;

  private mustShow: boolean = false;
  private embedModalActive: boolean = false;

  public mounted() {
    this.mustShow = true;
  }

  get isMobile(): boolean {
    if (mobileDetect.isMobile) {
      return true;
    } else {
      return false;
    }
  }

  get weetUrl(): string {
    return getWeetURL(this.weet);
  }

  public shareLink() {
    setActionEvent(ActionEvent.player_button_mini_share_link_mobile);
    // @ts-ignore
    const sharePromise = window.navigator.share({
      title: document.title,
      text: 'Hey, I want to share you this speach',
      url: this.weetUrl
    });
  }

  public shareEmbeddedWeet() {
    setActionEvent(ActionEvent.player_button_share);
    this.embedModalActive = true;
  }


  public copyLink() {
    setActionEvent(ActionEvent.player_button_mini_share_copy_link, {weetID: this.weet.weetID});
    copy(this.weetUrl);
    inform(this.$t('shareLinkButton.copy.confirmation').toString());
  }
}

</script>
<style scoped lang="scss">

.dropItemShareing {
  display: flex;
  vertical-align: middle;
  margin-left: 8px;
  margin-right: 8px;
  margin-bottom: 4px;
  width: calc(100% - 16px);
  border-radius: 4px;

  .sharingItem {
    display: flex;
    align-items: center;
    color: white;
    font-size: 16px;
    width: 100%;


    .socialLabel {
      padding-left: 8px;
      color: var(--black);
      min-width: 130px;
      width: 100%;

      &.copyLink {
      }

      &.embedLink {
      }


    }

  }
}
</style>
